(function () {
  'use strict';
  const windows = { US: [5, 8], CA: [10, 15], GB: [4, 8] };
  function calendarDay(now, zone) {
    if (!(now instanceof Date) || !Number.isFinite(now.getTime())) return null;
    if (zone === 'America/Edmonton' && now.getTime() >= Date.UTC(2026, 10, 1, 8)) {
      const albertaTime = new Date(now.getTime() - 6 * 60 * 60 * 1000);
      return new Date(Date.UTC(albertaTime.getUTCFullYear(), albertaTime.getUTCMonth(), albertaTime.getUTCDate(), 12));
    }
    try {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
    } catch (_) { return null; }
  }
  function addBusinessDays(day, count) {
    const result = new Date(day.getTime());
    let added = 0;
    while (added < count) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) added += 1;
    }
    return result;
  }
  function estimate(country, now, zone) {
    const window = windows[country];
    const day = calendarDay(now, zone);
    if (!window || !day) return null;
    return { day, start: addBusinessDays(day, window[0]), end: addBusinessDays(day, window[1]) };
  }
  function formatDeliveryRange(result, locale) {
    try {
      const fullFormatter = new Intl.DateTimeFormat(locale || 'en', { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' });
      const sameYear = result.start.getUTCFullYear() === result.end.getUTCFullYear() && result.start.getUTCFullYear() === result.day.getUTCFullYear();
      const compactFormatter = new Intl.DateTimeFormat(locale || 'en', { timeZone: 'UTC', ...(sameYear ? {} : { year: 'numeric' }), month: 'short', day: 'numeric' });
      const compact = typeof compactFormatter.formatRange === 'function' ? compactFormatter.formatRange(result.start, result.end) : compactFormatter.format(result.start) + ' – ' + compactFormatter.format(result.end);
      return { compact, full: fullFormatter.format(result.start) + ' – ' + fullFormatter.format(result.end), today: fullFormatter.format(result.day) };
    } catch (_) {
      const start = result.start.toISOString().slice(0, 10), end = result.end.toISOString().slice(0, 10);
      return { compact: start + ' – ' + end, full: start + ' – ' + end, today: result.day.toISOString().slice(0, 10) };
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calendarDay, addBusinessDays, estimate, formatDeliveryRange };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('wkt-delivery-estimate')) return;
  const instances = new Set();
  let country = null;
  let sourceCountry = null;
  let timer = null;
  const refresh = () => instances.forEach(instance => instance.update());
  class WktDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const initial = windows[this.dataset.country] ? this.dataset.country : 'OTHER';
      if (!country || sourceCountry !== this.dataset.country) {
        country = initial;
        sourceCountry = this.dataset.country;
      }
      this.select = this.querySelector('select');
      this.onChange = () => { country = this.select.value; refresh(); };
      this.select.addEventListener('change', this.onChange);
      instances.add(this);
      refresh();
      if (!timer) timer = setInterval(refresh, 30000);
    }
    disconnectedCallback() {
      if (this.select && this.onChange) this.select.removeEventListener('change', this.onChange);
      instances.delete(this);
      if (!instances.size && timer) { clearInterval(timer); timer = null; }
    }
    update() {
      this.select.value = country;
      const range = this.querySelector('[data-delivery-range]');
      const today = this.querySelector('[data-delivery-today]');
      const visual = this.querySelector('[data-delivery-visual]');
      const full = this.querySelector('[data-delivery-full]');
      const unknown = this.querySelector('[data-delivery-unsupported]');
      const result = estimate(country, new Date(), this.dataset.zone);
      const supported = Boolean(windows[country]);
      const freeShipping = this.querySelector('[data-delivery-free]');
      if (freeShipping) freeShipping.hidden = !supported;
      range.hidden = !supported;
      today.hidden = !result;
      unknown.hidden = supported;
      if (!supported) return;
      if (!result) { this.lastState = null; visual.textContent = full.textContent = this.dataset[country.toLowerCase() + 'Duration']; return; }
      const state = country + result.day.toISOString();
      if (state === this.lastState) return;
      this.lastState = state;
      const formatted = formatDeliveryRange(result, document.documentElement.lang || 'en');
      visual.textContent = formatted.compact;
      full.textContent = formatted.full;
      today.textContent = this.dataset.today.replace('__DATE__', formatted.today).replace('__ZONE__', this.dataset.zoneLabel);
    }
  }
  customElements.define('wkt-delivery-estimate', WktDeliveryEstimate);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
})();
